import Image from "next/image";
import Link from "next/link";
import React from "react";

import styles from "./Logo.module.scss";

interface LogoProps {
  white?: boolean;
  noLink?: boolean;
  href?: string;
  alt: string;
  style?: React.CSSProperties;
  className?: string;
}

export default function Logo({
  white = false,
  noLink = false,
  href = "/cs",
  alt,
  style,
  className,
}: LogoProps): React.ReactElement {
  const logoImage = (
    <Image
      className={className}
      style={style}
      width={106}
      height={28}
      src={white ? "/logo-white.svg" : "/logo.svg"}
      alt={alt}
    />
  );

  // noLink 속성이 true일 경우 링크 없이 이미지만 반환
  if (noLink) {
    return logoImage;
  }

  return (
    <Link href={href} className={styles.link}>
      <div className={styles.linkInner}>{logoImage}</div>
    </Link>
  );
}
